export default __webpack_public_path__ + "static/media/weather.b0e6ab9a.png";